const styles = {
  container: {
    width: '100%',
    marginTop: '.25rem !important',
    justifyContent: 'center !important',
  },
  fieldInput: {
    display: 'flex',
    maxWidth: '100%',
    width: '100%',
    textAlign: 'left',
    margin: '0 .25rem 0 0',
    outline: '0',
    tapHighlightColor: 'rgba(255,255,255,0)',
    lineHeight: '1.21em',
    padding: '.67857143rem 1rem',
    fontSize: '1em',
    background: '#fff',
    border: '.0625rem solid rgba(34,36,38,.15)',
    color: 'rgba(0,0,0,.87)',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 0 transparent inset',
    transition: 'color .1s ease,border-color .1s ease',
  },
  disabled: {
    background: '#e1e8ed',
  },
  fieldContainer: {},
  fieldArray: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  fieldLabel: {
    color: '#646464 !important',
    fontSize: '.875rem !important',
    fontWeight: '500 !important',
    margin: '0 0 .30rem 0',
    display: 'block !important',
  },
  monthlyBudgets: {
    margin: '-0.25rem !important',
    border: '.0625rem solid rgba(34,36,38,.15)',
    borderRadius: '0.3rem',
    width: '50rem',
    left: '5rem !important',
    position: 'relative',
    maxHeight: '16rem',
    overflow: 'auto',
  },
  monthlyBudgetsRow: {
    width: '50rem',
    justifyContent: 'space-between',
  },
  monthlyBudgetsTitle: {
    paddingTop: '1rem',
  },
};

export default styles;
